<template>
  <lay-out>
    <div class="my-egg-container">
      <div class="mem-page-title">
        我的恐龙蛋
        <span v-if="blanceData.pointNum > 0" class="egg-timeout"
          >您有{{ blanceData.pointNum }}个恐龙蛋将于
          {{ blanceData.validDate | setTimeDate }} 过期</span
        >
      </div>
      <div class="egg-count">
        <p>可用恐龙蛋</p>
        <p class="num">{{ eggNum }}</p>
        <router-link :to="{ name: 'EggBuy' }">
          <Button type="error" size="small" shape="circle" class="gobuy"
            >购买恐龙蛋</Button
          >
        </router-link>
      </div>
      <div class="mall-banner">
        <a :href="mallLink" target="_blank">
          <img class="bannerImg" src="@/assets/user/gomall-banner.png" alt />
          <div class="gomall">前去查看</div>
        </a>
      </div>
      <div class="egg-log">
        <div class="title">
          恐龙蛋明细
          <span class="p-l-10">（共{{ total }}条记录）</span>
          <a
            :href="`${VUE_APP_OLD_BASIC_URL}/help/questionDetail/egg-protocol`"
            target="_blank"
          >
            <span class="p-l-10 egg-detail">恐龙蛋说明</span>
          </a>
        </div>
        <div class="log-block" v-for="(item, index) in list" :key="index">
          <div class="title">{{ item.createTimeDisplay }}</div>
          <Timeline class="log-list">
            <TimelineItem
              color="#E56A69"
              v-for="child in item.recordList"
              :key="child.id"
            >
              <Row class="content">
                <Col :span="18">{{ child.changeTypeDisplay }}</Col>
                <Col :span="6" class="align-right">
                  {{ child.changePoint > 0 ? '获得了' : '消耗了' }}
                  <span class="c-red">{{ Math.abs(child.changePoint) }}</span>
                  恐龙蛋
                </Col>
              </Row>
            </TimelineItem>
          </Timeline>
        </div>
        <div class="aligin-center">
          <z-page
            :total="total"
            :elevator="true"
            :pageSize="filter.pageSize"
            v-model="filter.pageNum"
            @changePageNum="getMore"
          ></z-page>
        </div>
      </div>
    </div>
  </lay-out>
</template>

<script>
import axios from 'axios'
import LayOut from './layout'

export default {
  data() {
    return {
      mallLink: process.env.VUE_APP_MALL_EGG_URL,
      VUE_APP_OLD_BASIC_URL: process.env.VUE_APP_OLD_BASIC_URL,
      busy: false,
      filter: {
        pageSize: 10,
        pageNum: 1,
      },
      eggNum: 0,
      list: [],
      total: 0,
      msglenth: 0,
      blanceData: '',
    }
  },
  components: {
    LayOut,
  },
  watch: {
    list() {
      let temp = []
      this.list.forEach((item) => {
        temp = temp.concat(item.recordList)
      })
      this.msglenth = temp.length
    },
  },
  methods: {
    getTotal() {
      axios.get('/designer_api/points/balance').then((res) => {
        this.eggNum = res
      })
    },
    getDetail() {
      axios
        .get('/designer_api/points/detail/v2', {
          params: this.filter,
        })
        .then((res) => {
          this.total = res.total
          this.list = res.list
          this.busy = false
        })
    },
    getMore(val) {
      this.busy = true
      this.filter.pageNum = val
      axios
        .get('/designer_api/points/detail/v2', {
          params: this.filter,
        })
        .then((res) => {
          this.list = res.list
          this.busy = false
        })
    },

    getBlance() {
      axios.get('/designer_api/points/valid/points').then((res) => {
        this.blanceData = res
      })
    },
  },
  created() {
    this.getTotal()
    this.getDetail()
    this.getBlance()
  },
  activated() {},
}
</script>

<style lang="scss" scoped>
.my-egg-container {
  background: #fff;
  .egg-timeout {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFangSC;
    font-weight: 500;
    color: rgba(160, 160, 160, 1);
    float: right;
  }
  .egg-count {
    height: 150px;
    padding-top: 30px;
    text-align: center;
    position: relative;
    p {
      font-size: 18px;
      font-weight: 600;
      line-height: 25px;
    }
    .num {
      font-size: 60px;
      font-family: 'PingFangSC-Medium', 'Microsoft Yahei';
      font-weight: bold;
      line-height: 60px;
      margin-top: 12px;
    }
    .gobuy {
      position: absolute;
      top: 67px;
      right: 36px;
    }
  }
  .mall-banner {
    height: 154px;
    background: rgba(255, 237, 237, 1);
    position: relative;
    .bannerImg {
      width: 100%;
      height: 154px;
      object-fit: cover;
    }
    .gomall {
      width: 90px;
      height: 28px;
      line-height: 26px;
      border-radius: 14px;
      font-size: 14px;
      font-weight: 500;
      text-align: center;
      border: 1px solid #979797;
      position: absolute;
      bottom: 12px;
      left: 0;
      right: 0;
      margin: auto;
      transition: all 0.2s;
    }
    &:hover {
      .gomall {
        color: #fff;
        background-color: #313131;
        border-color: #313131;
      }
    }
  }
  .egg-log {
    width: 730px;
    margin: 0 auto;
    padding: 30px 0;
    .title {
      font-size: 14px;
      font-weight: 500;
      color: #4a4a4a;
      padding-bottom: 15px;
    }
    .log-block {
      margin-top: 20px;
      .title {
        padding-left: 5px;
        padding-bottom: 15px;
      }
      .log-list {
        .ivu-timeline-item {
          &:first-child {
            padding-top: 20px !important;
          }
          &:last-child {
            .ivu-timeline-item-tail {
              display: block !important;
              left: 5 !important;
            }
          }
          .ivu-timeline-item-head {
            width: 11px !important;
            height: 11px !important;
          }
        }
      }
      .ivu-timeline-item-head {
        background-color: #e56a69 !important;
      }
    }
  }
  .egg-detail {
    float: right;
    vertical-align: middle;
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>
